export const BENEFITS = {
  heading: 'What are the benefits of a Gousto food box?',
  benefits: [
    {
      title: 'Best value',
      description:
        'We deliver high-quality ingredients to your door, any day you like. With the lowest food box delivery fee of other food box options out there.',
    },
    {
      title: 'Biggest Menu',
      description:
        'Over 175 recipes to choose from every week, way more than other food box providers.',
    },
    {
      title: 'Reducing plastic',
      description:
        'In 2024, we removed 75.9 tonnes of plastic from our boxes, not least thanks to our Eco Chill Box insulation made with recycled paper. Next on the list? Making all Gousto-branded packaging reusable, recyclable or compostable.',
    },
    {
      title: 'No lock-ins',
      description:
        'You can skip or pause your subscription any time you like at the touch of a button.',
    },
  ],
  ctaText: 'See our impact',
  altText:
    'Recipe cards held over fresh, pre-portioned ingredients in an insulated Gousto meal kit',
}
